module.exports = __webpack_public_path__ + "kz.svg?51d935d5514904b8cd4a00ce757f26ac";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kz.svg
// module id = 1051
// module chunks = 27